export const TOP_5_BETS = ['market-statistics', 'top-ranking', 'top5bets'];
export const TOP10_LIVE_TAB = 'top10_live';
export const TOP10_PREMATCH_TAB = 'top10_prematch';
